module.exports = __webpack_public_path__ + "static/media/officePic.9ea78c16.jpg";